import React, { Component } from "react";
let static_root = window.location.origin + "/vmserver/raw_activities/";
// 
// 
// 
function construct_event_frames(events){
        
    let frames = [];
    let current_grabbed_image = {};
    let current_activity_image = {};
    let cams = new Set();
    let dimensions = {}

    events.forEach((event) =>{
        // console.log(event);
        let cam_name = event.cam_name;
        cams.add(cam_name);
        dimensions[cam_name] = [event.grabbed_height, event.grabbed_width];

        current_grabbed_image[cam_name] = event.grabbed_path;
        current_activity_image[cam_name] = event.activity_path;

        let cams_uri_grabbed = {}
        for (const [key, val] of Object.entries(current_grabbed_image)){
            cams_uri_grabbed[key] = val;
        }
        let cams_uri_activity = {}
        for (const [key, val] of Object.entries(current_activity_image)){
            cams_uri_activity[key] = val;
        }


        frames.push({
            "event_time": event.event_time,
            "cams_uri_grabbed": cams_uri_grabbed,
            "cams_uri_activity": cams_uri_activity
        });


    });

    let _cams = Array.from(cams);
    _cams.sort();
    return {cams:_cams, dimensions, frames};
}

function get_frame_images(key_prefix, cams, image_style, image_class_name, frame, type, click_handler){

    let images = [];
    let frame_index = `cams_uri_${type}`;
    for(const cam of cams){
        
        if (cam in frame[frame_index]){
            // console.log("pushing ", cam, frame_index)
            let image = undefined
            if (click_handler){
                image = <img 
                    key={key_prefix + type + cam}
                    className={image_class_name} 
                    style={image_style}
                    src= {static_root + frame[frame_index][cam]} 
                    onClick ={click_handler}
                    />;
            }
            else{
                image = <img 
                key={key_prefix + type + cam}
                className={image_class_name} 
                style={image_style}
                src= {static_root + frame[frame_index][cam]} 
                />;

            }
            images.push(image)
        }
    }
    return images;

}
function construct_time_lapse(cams, frames, select_n_frames, component){
    let images = [];
    let index = 0;
    // frames.length / 
    let index_bin = parseInt(Math.ceil(frames.length / select_n_frames));
    // debugger;
    // let add_extra = true;
    // if (frames.length % select_n_frames){
    //     add_extra = false;
    // }
    
    for (let frame of frames){
        if (index == 0 && frames.length > select_n_frames){
            index += 1;
            continue;
        }
        if (index % index_bin == 0){
            let sub_index = 0;
            // clickHandler={() => this.selectActivityThumb(index)}
            let click_index = index;
            let _images = get_frame_images(
                `tlapse_${index}_${sub_index}`, 
                [cams[0]],
                {},
                "ac-sm-time_lapse-img",
                frame, 
                "activity",
                () => component.goToLapseImage(click_index)
            );
            // console.log("added images", index);
            for (let image of _images){
                images.push(image);
                sub_index += 1;
            }
        }
        index +=1;

    }
    return images;

}

function calculateImageStyle(cams, dimensions){
    
    let image_style = {};
    let container = document.getElementById("ac-sm-container");
    if (container === null){
        return {};
    }
    let view_height = container.clientHeight;
    if (cams.length == 2){
        view_height /= 2;
    }

    // let view_width = window.visualViewport.width*0.7;
    let view_width = document.documentElement.clientWidth *0.7;

    let width=0
    let height=0;
    for(const cam of cams){
        if (dimensions[cam][0] > height){
            height = dimensions[cam][0];
        } 
        if (dimensions[cam][1] > width){
            width = dimensions[cam][1];
        } 

    }
    let ratio = width/height;



    let image_width = Math.round(view_height*ratio);
    let image_height = view_height;
    if (image_width > view_width){
        image_width = view_width- 10;
        image_height = Math.round(image_width/ratio);
        // console.log("calcualte style shrink high", image_width, image_height)
    }
    image_style["width"] = `${image_width}px`;
    image_style["height"] = `${image_height}px`;
    // console.log("calcualte style  image style", image_style)
    return image_style
}


class ActivityStopMotion extends Component {
    constructor() {
        super();
        this.goToNextFrame = this.goToNextFrame.bind(this);
        this.goToPrevFrame = this.goToPrevFrame.bind(this);
        this.update = this.update.bind(this);
        this.onSliderChange = this.onSliderChange.bind(this);
        
        
        
        this.state = {
            frame_index: 0,
            trigger: 0,
            frames: []
        }
    }
    componentDidMount(){
        // this.updateEvents();
        window.addEventListener("resize", this.update);
        this.setState({ frame_index : this.props.top_event_index - 1})
        
    }
    componentWillUnmount(){
        window.removeEventListener("resize", this.update);
    }
    update(){
        this.setState({trigger: this.state.trigger+1})
    }
    goToPrevFrame() {
        if( this.state.frame_index > 0){
            this.setState({frame_index: this.state.frame_index - 1});
        }

    }

    goToNextFrame() {
        if( this.state.frame_index < this.total_frames - 1){
            this.setState({frame_index: this.state.frame_index + 1});
        }

        
    }
    onSliderChange(event) {
        let value = parseInt(event.target.value);
        // console.log(this.state.frame_index, this.total_frames, value)
        this.setState({frame_index: value})
    }
    goToLapseImage(index){
        // console.log(index)
        this.setState({frame_index: index});
    }


    render() {
        
        // console.log(container.innerWidth,container.innerHeight );
        
        // container.clientHeight;
        let {cams,dimensions,frames} = construct_event_frames(this.props.events);
        this.total_frames = frames.length;
        let time_lapse_images = construct_time_lapse(cams, frames, 5, this);
        
        let image_style = calculateImageStyle(cams, dimensions);
        let image_class_name = `ac-sm-image-${cams.length}`;
        let images = [];
        let frame = frames[this.state.frame_index];
        if (frame !== undefined){
            // console.log(frames[this.state.frame_index])
            images = get_frame_images(
                'main',
                cams,
                image_style,
                image_class_name,
                frames[this.state.frame_index],
                "grabbed",
                undefined
                );
        }
        return (
            <div className="ac-sm-images-container">
                <div className="ac-sm-time_lapse">{time_lapse_images}</div>
                {images}
                <div className="ac-sm-controls">
                    <button onClick={this.goToPrevFrame} className="button-container ac-sm-control fa fa-chevron-left" />
                    <input 
                        className="ac-sm-slider"
                        type="range" 
                        min="0" 
                        value={this.state.frame_index} 
                        max={this.total_frames - 1} 
                        onChange={this.onSliderChange}
                        step="1"
                    />
                    <button onClick={this.goToNextFrame} className="button-container ac-sm-control fa fa-chevron-right" />
                </div>
            </div>
        )
    }
}

export default ActivityStopMotion;
